import Payments from '../ui/Payments'
import { connect } from 'react-redux'
import { paymentsSubmit, skipSubmit, goBack, fetchHostIfNeeded, invalidateHost, fetchHost } from '../../actions'

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    content: state.content,
    user: state.user,
    host: state.host,
    territory: state.territory,
    requiredFields: state.requiredFields
  });

const mapDispatchToProps = dispatch =>
  ({
    onPaymentsSubmit(payload) {
      dispatch(invalidateHost())
      dispatch(
        paymentsSubmit(payload)
      )
      dispatch(fetchHostIfNeeded())
    },
    onSkipSubmit(payload) {
      dispatch(
        skipSubmit(payload)
      )
    },
    onFetchHostIfNeeded(payload) {
      dispatch(fetchHostIfNeeded())
    },
    onRoomsRefresh(payload) {
      dispatch(invalidateHost())
      dispatch(fetchHostIfNeeded())
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Payments);

export default Container;
